import React from "react";
import {HiMinus, HiPlus} from "react-icons/hi";

const Product = ({product, selectedQty, selectedProducts, setSelectedProducts}) => {
  const {id, name, description, price} = product;

  const addProduct = (product) => {
    setSelectedProducts((prev) => {
      const foundProduct = selectedProducts.find(({id}) => id === product.id);

      if (foundProduct) {
        return prev.map((p) => (p.id === product.id ? {...p, qty: p.qty + 1} : p));
      }

      return [...prev, {...product, qty: 1}];
    });
  };

  const removeProduct = (productId) => {
    setSelectedProducts((prev) => {
      const foundProduct = selectedProducts.find(({id}) => id === productId);

      if (foundProduct) {
        if (foundProduct.qty > 1) {
          return prev.map((p) => (p.id === productId ? {...p, qty: p.qty - 1} : p));
        }
        return prev.filter((p) => p.id !== productId);
      }

      return prev;
    });
  };

  return (
    <div
      key={id}
      className="flex items-center align-middle mb-2 py-3 pr-3 transition duration-300 justify-between rounded-2xl border-1 shadow-md"
    >
      <div className='flex items-center'>
        <div
          onClick={() => removeProduct(id)}
          className="p-1 bg-gray-200 text-gray-900 mx-3 rounded-full active:opacity-70 active:text-opacity-70 cursor-pointer transition duration-300"
        >
          <HiMinus size={16}/>
        </div>
        <div className="text font-semibold">{selectedQty}</div>
        <div
          onClick={() => addProduct(product)}
          className="p-1 bg-gray-200 text-gray-900 mx-3 rounded-full active:opacity-70 active:text-opacity-70 cursor-pointer"
        >
          <HiPlus size={16}/>
        </div>
        <div className="flex flex-col mx-1">
          <div className="text-sm font-[600]">{name}</div>
          <div className="text-xxs my-0.5"
               style={{
                 overflow: 'hidden',
                 display: '-webkit-box',
                 WebkitBoxOrient: 'vertical',
                 WebkitLineClamp: 2,
               }}>{description}</div>
        </div>
      </div>
      <div className="flex items-center">
        <div className="text-gray-900 font-[600] tex-sm whitespace-nowrap">{price}</div>
      </div>
    </div>
  );
};

export default Product;